import * as Connector from 'shared/connectors/notificationConnector';
import { NOTIFICATION } from 'store/types';

const init = () => ({
  type: NOTIFICATION.GET_NOTIFICATIONS_INIT,
});

export const success = data => ({
  type: NOTIFICATION.GET_NOTIFICATIONS_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: NOTIFICATION.GET_NOTIFICATIONS_FAILURE,
});

const getNotifications = (params = null) => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getNotifications(params);
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getNotifications;
